import React,  {Component} from 'react';
import {Button} from 'react-bootstrap'
import {Box, Card, Image, Heading, Text} from 'rebass';
import Modal from 'react-bootstrap/Modal';

export class SimpleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active_menu: "Profile"
    };

    this.func = this.func.bind(this);
  }
  func(e) {
    this.setState({
      active_menu: e.target.id
    });

    // change contents
    this.props.func(e.target.id);
  }

  render() {
    return (
        <ul className='sidebar_list'
          style={{
                listStyleType: "none",
                padding: 0,
                width: '100%',
                margin: 'auto'
            }}>
            {this.props.list.map(item => (
            <li key={item}
              style={{padding: 20}}>
                <div id={item} className={['sidebar_point', this.state.active_menu === item ?  ' sidebar_point_active' : ''].join(' ').trim()}></div>
                <div id={item} className={['sidebar_name', this.state.active_menu === item ?  ' sidebar_name_active' : ''].join(' ').trim()} style={{textAlign: 'center'}} onClick={this.func}>{item}</div>
            </li>
            ))}
        </ul>
    )
  }
}

export class CardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  openModal() {
    this.setState({modalShow: true});
  }
  afterOpenModal() {
      // references are now sync'd and can be accessed.
      // this.subtitle.style.color = '#f00';
  }
  closeModal() {
      this.setState({modalShow: false});
  }
  render () {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
      <Box width={256} margin={3}
      onClick={this.openModal}>
          <Card
              p={1}
              borderRadius={2}
              boxShadow='0 0 16px rgba(0, 0, 0, .25)'>
              <Image src={this.props.card_img} />
              <Box px={2}>
              <Heading as='h3'>
                  {this.props.card_title}
              </Heading>
              <Text fontSize={0}>
                {this.props.card_text}
              </Text>
              </Box>
          </Card>
      </Box>
      <Modal
          show={this.state.modalShow}
          onHide={modalClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          >
          <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
              {this.props.card_title}
          </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div style={{whiteSpace: 'pre-line'}}>
            {this.props.card_desc.split('<br />').map(function(line) {
              return (<p key='0'>{line}</p>);}
            )}
          </div>
          </Modal.Body>
          <Modal.Footer>
          <Button onClick={this.closeModal} variant="primary">Close</Button>
          </Modal.Footer>
      </Modal>
      </div>
    );
  }
}

export class DataList extends Component {
  render () {
    return (
      <dl style={{whiteSpace: 'pre-line'}}>
        {this.props.array.reduce((acc, item, idx) => {
            return acc.concat([
                <dt key={`def-${idx}`}>{item.def}</dt>,
                <dd key={`term-${idx}`}>{item.term.split('<br />').map(function(line) {
                  return (<p>{line}</p>);})}
                </dd>
            ]);
        }, [])}
      </dl>
    );
  }
}
